import { Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { ReservationComponent } from './pages/reservation/reservation.component';
import { TermsComponent } from './shared/components/terms/terms.component';
import { PoliciesComponent } from './shared/components/policies/policies.component';
import { ConfirmReservationComponent } from './pages/confirm-reservation/confirm-reservation.component';
import { autorizedGuard } from './core/guards/autorized.guard';
import { tokenExpiredGuard } from './core/guards/token-expired.guard';
import { ErrorPageComponent } from './pages/error-page/error-page.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'reservation',
    component: ReservationComponent,
  },
  {
    path: 'reservation/:id',
    component: ReservationComponent,
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./pages/home/home.component').then((p) => p.HomeComponent),
    canActivate: [autorizedGuard, tokenExpiredGuard],
  },
  {
    path: 'unit/hall',
    loadComponent: () =>
      import('./pages/main/main.component').then((p) => p.MainComponent),
    canActivate: [autorizedGuard, tokenExpiredGuard],
    children: [
      {
        path: 'grid',
        loadComponent: () =>
          import('./pages/hall/hall.component').then((p) => p.HallComponent),
      },
      {
        path: 'time-table/:id',
        loadComponent: () =>
          import('./pages/hall-timetable/hall-timetable.component').then(
            (p) => p.HallTimetableComponent,
          ),
      },
      {
        path: 'block',
        loadComponent: () =>
          import('./pages/block-time/block-time.component').then(
            (p) => p.BlockTimeComponent,
          ),
      },
      {
        path: 'special-dates',
        loadComponent: () =>
          import('./pages/special-dates/special-dates.component').then(
            (p) => p.SpecialDatesComponent,
          ),
      },
      {
        path: 'configuration',
        loadComponent: () =>
          import(
            './pages/configuration-store/configuration-store.component'
          ).then((p) => p.ConfigurationStoreComponent),
      },
      {
        path: 'link-manager',
        loadComponent: () =>
          import('./pages/link-manager/link-manager.component').then(
            (p) => p.LinkManagerComponent,
          ),
      },
      {
        path: 'desk-manager',
        loadComponent: () =>
          import('./pages/queue-management/queue-management.component').then(
            (p) => p.QueueManagementComponent,
          ),
      },
    ],
  },

  {
    path: 'terms',
    component: TermsComponent,
  },
  {
    path: 'policies',
    component: PoliciesComponent,
  },
  {
    path: 'confirm',
    component: ConfirmReservationComponent,
  },
  {
    path: '**',
    component: ErrorPageComponent,
  },
];
